export const getCurrentDateTime = () => {
    const now = new Date();
    
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(now.getDate()).padStart(2, '0');
    
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    const currentDate = `${year}-${month}-${day}`;
    const currentTime = `${hours}:${minutes}:${seconds}`;
    return `${currentDate}_${currentTime}`;
  };
  
  export const localToUTC=(dateString,isMillisecond)=> {
    // Create a date object from the provided date string
    const localDate = new Date(dateString);
  
    // Get the timezone offset in minutes and convert it to milliseconds
    const timezoneOffset = localDate.getTimezoneOffset() * 60000;
  
    // Create a new Date object in UTC by subtracting the offset
    const utcDate = new Date(localDate.getTime() + timezoneOffset);
  
    // Get the individual components of the UTC date
    const year = utcDate.getUTCFullYear();
    const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(utcDate.getUTCDate()).padStart(2, '0');
    const hours = String(utcDate.getUTCHours()).padStart(2, '0');
    const minutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utcDate.getUTCSeconds()).padStart(2, '0');
    const milliseconds = isMillisecond? String(utcDate.getUTCMilliseconds()).padStart(6, '0') :"";
    // Format the UTC date as YYYY-MM-DD HH:mm:ss
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}${`.${milliseconds}`}`;
  };
  